import React , {useEffect} from 'react';
import styled from 'styled-components';


//모달 창 배경
export default function TopModalbar(props) {


    useEffect(() => {
        const timer = setTimeout(() => {
            props.setShowModalTop(false);
        }, 1000);
        return () => clearTimeout(timer);
      }, [props]);

    return (
        props.showModalTop ? 
            <TopModal
                setShowModalTop={props.setShowModalTop}
                top={props.top}>{props.text}
            </TopModal>
        :
        null    
    )
}


const TopModal = styled.div`
    position: fixed;
    top: ${props=> props.top};
    left: 50%;
    z-index: 200;
    transform: translateX(-50%);
    width: calc(100vw*(362/375));
    height: calc(100vw*(49/375));;
    border-radius: calc(100vw*(9/375));
    background-color: #ffcf19;
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    line-height: calc(100vw*(49/375));
    text-align: center;
    color: #4e4e4e;
    z-index: 200;
`